module.exports = {
    "collectionLabel": `Pasi\u{16B}lymai`
};


//# sourceMappingURL=lt-LT.main.js.map
